package org.braunequip.web.components.widgets

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.AlignItems
import com.varabyte.kobweb.compose.css.JustifyContent
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.functions.url
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.braunequip.web.util.Constants
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

val RentalCardContainer = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Flex)
            .overflow(Overflow.Auto)
            .flexDirection(FlexDirection.Row)
            .justifyContent(JustifyContent.Center)
            .alignItems(AlignItems.Center)
            .flexWrap(FlexWrap.Wrap)
            .margin(leftRight = autoLength)
            .padding(topBottom = 10.px)
    }
    Breakpoint.MD {
        Modifier
    }
}

val RentalCardStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Colors.WhiteSmoke)
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Column)
            .justifyContent(JustifyContent.Start)
            .borderRadius(5.px)
            .padding(10.px)
            .margin(5.px)

            .transition(Transition.Companion.of("ease-in-out", .25.s))
            .cursor(Cursor.Pointer)

            .flexBasis(80.percent)
    }
    Breakpoint.MD {
        Modifier
            .flexBasis(25.percent)       //Keep this to allow for two columns
            .flexGrow(0)           //Allow divs to grow if space is available
            .flexShrink(0)         //Allow divs to shrink as necessary

            .minWidth(350.px)
            .maxWidth(350.px)      //Set a maximum width to control size before
            .maxHeight(350.px)
            .minHeight(350.px)
    }
    hover {
        Modifier
            .backgroundColor(Colors.LightGray)
            .transform {
                scale(.95)
            }
    }
}

val RentalImageContainer = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Flex)
            .justifyContent(JustifyContent.Center)
            .backgroundColor(Colors.White)
            .boxShadow(0.px, 5.px, 15.px, color = Color.rgba(0, 0, 0, 0.1f))
            .border(2.px, LineStyle.Solid, Colors.Black)
            .borderRadius(2.px)
            .width(autoLength)
            .height(250.px)
    }
    Breakpoint.MD {
        Modifier
            .height(180.px)
    }
}

val RentalImageStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Block)
            .width(100.percent)
            .height(100.percent)
            .objectFit(ObjectFit.Cover)
    }
}

val RentalNameTitle = CssStyle {
    base {
        Modifier
            .padding(topBottom = 2.px)
            .fontWeight(FontWeight.Bold)
            .textAlign(TextAlign.Start)
            .fontFamily(Constants.FONT_FAMILY2)
            .color(Colors.Black)
    }
}

val RentalNameSubtitle = CssStyle {
    base {
        Modifier
            .fontSize(1.cssRem)
            .padding(topBottom = 2.px)
            .fontWeight(FontWeight.Lighter)
            .textAlign(TextAlign.Start)
            .fontFamily(Constants.FONT_FAMILY2)
            .color(Colors.Black)
    }
}


@Composable
fun RentalCard(image: String, title: String, description: String,) {
    Div(RentalCardStyle.toAttrs()) {
        Div(RentalImageContainer.toAttrs()) {
            Img(src = "$image", alt = "$title", attrs = RentalImageStyle.toAttrs())
        }

        SpanText(title, RentalNameTitle.toModifier().padding(top = 10.px, bottom = 2.px))
        SpanText(description, RentalNameSubtitle.toModifier())
    }
}



